export default {
  setAbout: (state, payload) => { state.about = payload },
  setHome: (state, payload) => { state.home = payload },
  setContact: (state, payload) => { state.contact = payload }
}